module.exports = __webpack_public_path__ + "media/vue/assets/images/booking-service/discover-store-events-979bf6b8528b3f2a86cb18db17c82cfc.jpg";